import { useEffect, useState } from 'react';
import { Places } from '../services';
import { places_seat_categories } from '../services/pricingCategories';

let cachedSuggestions = null;
let inflight = null;

const loadSuggestions = () => {
    if (cachedSuggestions)
        return Promise.resolve(cachedSuggestions);
    if (!inflight) {
        inflight = Places.list({ fields: ['_id', 'map'] })
            .then((data) => {
                cachedSuggestions = places_seat_categories(data.places);
                return cachedSuggestions;
            })
            .catch(() => {
                cachedSuggestions = [];
                return cachedSuggestions;
            })
            .finally(() => {
                inflight = null;
            });
    }
    return inflight;
};

/**
 * Distinct seat categories found on place maps (suggestions for free-text multi-selects).
 * Keeps a process-wide cache so BucketForm / PricingForm remounts do not refetch.
 *
 * @returns {string[]}
 */
export default function usePlacesSeatCategorySuggestions() {
    const [suggestions, setSuggestions] = useState(() => cachedSuggestions || []);

    useEffect(() => {
        let cancelled = false;
        loadSuggestions().then((cats) => {
            if (!cancelled)
                setSuggestions(cats);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return suggestions;
}
